(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-video-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-video-carousel')) {
    customElements.define(
      'review-video-carousel',
      class ReviewVideoCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-review-track]');
          this.previousButton = this.querySelector('[data-review-previous]');
          this.nextButton = this.querySelector('[data-review-next]');

          this.previousButton?.addEventListener('click', () => this.move(-1));
          this.nextButton?.addEventListener('click', () => this.move(1));
        }

        move(direction) {
          const card = this.track?.querySelector('.customer-video-reviews__card');
          if (!card || !this.track) return;

          const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
